import * as React from 'react';
import Icon from './Icon';
import { IIconProps } from './Icon.interfaces';

export default Icon as any as React.StatelessComponent<IIconProps>;
